import { useEffect, useState } from "react";
import { Search, UserPlus, Check, Ban } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel, Empty } from "@/components/common";
import { UserAvatar } from "@/components/UserAvatar";
import { api, errMsg } from "@/lib/api";

const LABEL = { accepted: "Collegato", outgoing: "Richiesta inviata", incoming: "Ti ha chiesto il collegamento", blocked: "Bloccato" };

export function SearchAdmins({ onChange }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const load = (query) => api.get("/network/search", { params: { q: query } }).then((r) => setItems(r.data));
  useEffect(() => {
    const t = setTimeout(() => load(q), 300);
    return () => clearTimeout(t);
  }, [q]);
  const act = async (fn, msg) => {
    try { await fn(); toast.success(msg); load(q); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <div className="relative mb-4 max-w-sm">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9" placeholder="Cerca amministratori per nome" value={q} onChange={(e) => setQ(e.target.value)} data-testid="netsoci-search-input" />
      </div>
      {items && items.length === 0 ? <Empty icon={Search} text="Nessun amministratore trovato." /> : (
        <Panel testId="netsoci-search-results">
          <ul className="divide-y">
            {(items || []).map((a) => (
              <li key={a.id} className="flex flex-wrap items-center gap-3 px-5 py-3" data-testid={`netsoci-result-${a.id}`}>
                <UserAvatar name={a.name} />
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-medium">{a.name}</span>
                  <span className="block truncate text-xs text-muted-foreground">{[a.job_title || a.role, a.company].filter(Boolean).join(" · ")}</span>
                </span>
                {a.status === "none" && <Button size="sm" onClick={() => act(() => api.post("/network/connections", { user_id: a.id }), "Richiesta di collegamento inviata")} data-testid={`netsoci-connect-${a.id}`}><UserPlus className="mr-1.5 h-4 w-4" />Collegati</Button>}
                {a.status === "incoming" && <Button size="sm" onClick={() => act(() => api.post(`/network/connections/${a.connection_id}/respond`, { accept: true }), "Collegamento accettato")} data-testid={`netsoci-accept-${a.id}`}><Check className="mr-1.5 h-4 w-4" />Accetta</Button>}
                {a.status === "blocked" ? <Button size="sm" variant="outline" onClick={() => act(() => api.delete(`/network/block/${a.id}`), "Contatto sbloccato")} data-testid={`netsoci-unblock-${a.id}`}>Sblocca</Button>
                  : a.status !== "none" && <span className="text-xs font-medium text-primary" data-testid={`netsoci-status-${a.id}`}>{LABEL[a.status]}</span>}
                {a.status !== "blocked" && <Button size="icon" variant="ghost" className="h-8 w-8 text-muted-foreground" aria-label="Blocca" onClick={() => act(() => api.post(`/network/block/${a.id}`), "Contatto bloccato")} data-testid={`netsoci-block-${a.id}`}><Ban className="h-4 w-4" /></Button>}
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
